import { useTitle } from "ahooks";

const DEFAULT_PAGE_TITLE = "EngineEars";

export const useSetPageTitle = (title: string | undefined) => {
  useTitle(title ? `${title} | ${DEFAULT_PAGE_TITLE}` : DEFAULT_PAGE_TITLE, {
    restoreOnUnmount: true,
  });
};
